/* unplugin-vue-components disabled */import { render } from "./tenant-feed.vue?vue&type=template&id=09600166&scoped=true"
import script from "./tenant-feed.vue?vue&type=script&lang=js"
export * from "./tenant-feed.vue?vue&type=script&lang=js"

import "./tenant-feed.vue?vue&type=style&index=0&id=09600166&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09600166"],['__file',"src/pages/tenant/settings/tenant-feed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09600166"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09600166', __exports__)) {
    api.reload('09600166', __exports__)
  }
  
  module.hot.accept("./tenant-feed.vue?vue&type=template&id=09600166&scoped=true", () => {
    api.rerender('09600166', render)
  })

}


export default __exports__